"use strict";
/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingAccountImpl = void 0;
const tslib_1 = require("tslib");
const coreClient = tslib_1.__importStar(require("@azure/core-client"));
const Mappers = tslib_1.__importStar(require("../models/mappers.js"));
const Parameters = tslib_1.__importStar(require("../models/parameters.js"));
/** Class containing BillingAccount operations. */
class BillingAccountImpl {
    client;
    /**
     * Initialize a new instance of the class BillingAccount class.
     * @param client Reference to the service client
     */
    constructor(client) {
        this.client = client;
    }
    /**
     * Get Billing Account Policy.
     * @param billingAccountId Billing Account Id.
     * @param options The options parameters.
     */
    getPolicy(billingAccountId, options) {
        return this.client.sendOperationRequest({ billingAccountId, options }, getPolicyOperationSpec);
    }
}
exports.BillingAccountImpl = BillingAccountImpl;
// Operation Specifications
const serializer = coreClient.createSerializer(Mappers, /* isXml */ false);
const getPolicyOperationSpec = {
    path: "/providers/Microsoft.Billing/billingAccounts/{billingAccountId}/providers/Microsoft.Subscription/policies/default",
    httpMethod: "GET",
    responses: {
        200: {
            bodyMapper: Mappers.BillingAccountPoliciesResponse
        },
        default: {
            bodyMapper: Mappers.ErrorResponseBody
        }
    },
    queryParameters: [Parameters.apiVersion1],
    urlParameters: [Parameters.$host, Parameters.billingAccountId],
    headerParameters: [Parameters.accept],
    serializer
};
//# sourceMappingURL=billingAccount.js.map